<template>
  <div>
    <div class="d-flex flex-wrap align-items-center justify-content-between mb-1">
      <div class="mb-0">
        <slot name="title" />
      </div>
      <b-button
        variant="outline-primary"
        size="sm"
        class="mt-1 mt-md-0"
        @click="aiModalShow = true"
      >
        <FeatherIcon
          icon="ZapIcon"
          size="16"
          class="mr-50"
        />
        {{ $t('poster.ai_generate_button') }}
      </b-button>
    </div>
    <poster-ai-generate-modal
      :show.sync="aiModalShow"
      :default-platform="defaultPlatform"
      @generated="$emit('generated', $event)"
    />
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import PosterAiGenerateModal from './PosterAiGenerateModal.vue'

export default {
  name: 'PosterAiGenerateTrigger',
  components: {
    BButton,
    PosterAiGenerateModal,
  },
  props: {
    defaultPlatform: {
      type: String,
      default: 'Facebook',
      validator: v => v === 'Facebook' || v === 'Instagram',
    },
  },
  data() {
    return {
      aiModalShow: false,
    }
  },
}
</script>
